export default __webpack_public_path__ + "static/media/styczen.8f4971b4.mp3";